// TODO: для продакшна: export const MINUTES_TO_MS = 60000;
export const MINUTES_TO_MS = 1000;

export const hintTexts = {
    HINT_TEXT_INVITE_COLLEAGUE: 'hintTexts.HINT_TEXT_INVITE_COLLEAGUE',
    HINT_TEXT_DASHBOARD_INFO_1: 'hintTexts.HINT_TEXT_DASHBOARD_INFO_1',
    HINT_TEXT_DASHBOARD_INFO_2: 'hintTexts.HINT_TEXT_DASHBOARD_INFO_2',
    HINT_TEXT_DASHBOARD_INFO_3: 'hintTexts.HINT_TEXT_DASHBOARD_INFO_3',
    HINT_TEXT_DASHBOARD_INFO_4: 'hintTexts.HINT_TEXT_DASHBOARD_INFO_4',
    HINT_TEXT_ESTIMATE_INFO_1: 'hintTexts.HINT_TEXT_ESTIMATE_INFO_1',
    HINT_TEXT_ESTIMATE_INFO_2: 'hintTexts.HINT_TEXT_ESTIMATE_INFO_2',
    HINT_TEXT_ESTIMATE_INFO_3: 'hintTexts.HINT_TEXT_ESTIMATE_INFO_3',
    HINT_TEXT_ESTIMATE_INFO_4: 'hintTexts.HINT_TEXT_ESTIMATE_INFO_4',
    HINT_TEXT_ESTIMATE_INFO_5: 'hintTexts.HINT_TEXT_ESTIMATE_INFO_5',
    HINT_TEXT_SCHEDULE_INFO_1: 'hintTexts.HINT_TEXT_SCHEDULE_INFO_1',
    HINT_TEXT_SCHEDULE_INFO_2: 'hintTexts.HINT_TEXT_SCHEDULE_INFO_2',
    HINT_TEXT_SCHEDULE_INFO_3: 'hintTexts.HINT_TEXT_SCHEDULE_INFO_3',
    HINT_TEXT_ADD_PROJECT: 'hintTexts.HINT_TEXT_ADD_PROJECT',
    HINT_TEXT_BEHAVIOUR_TYPE_NEXT_LABEL: 'hintTexts.HINT_TEXT_BEHAVIOUR_TYPE_NEXT_LABEL',
    HINT_TEXT_BEHAVIOUR_EXPAND_ALL_LABEL: 'hintTexts.HINT_TEXT_BEHAVIOUR_EXPAND_ALL_LABEL',
    HINT_TEXT_BEHAVIOUR_OK_LABEL: 'button.got_it.text',
};
